import template from './performance_cycle_ratings_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class PerformanceCycleRatingsHelpViewModel {
    constructor(dialog) {
        this.dialog = dialog
        this.step_sequence = ko.observable(1)
    }

    close() {
        this.dialog.close()
    }

    move_order_up() {
        this.step_sequence(this.step_sequence() + 1)
    }

    move_order_down() {
        this.step_sequence(this.step_sequence() - 1)
    }
}

class PerformanceCycleRatingsHelpPage {
    constructor(bindings) {
        this.viewModel = new PerformanceCycleRatingsHelpViewModel(this);
        this.bindings = bindings
    }

    init() {
        Utils.refresh_data_visible_roles()
    }
}

export default {
    name: 'PerformanceCycleRatingsHelp',
    dialog_class: PerformanceCycleRatingsHelpPage,
    template: template,
    template_filename: 'translation/dialogs/performance_cycle_ratings_help',
    provider: 'ps',
}
